import React, { useEffect, useMemo, useRef, useState, useCallback } from "react";
import "./CardOverlay.css";

export default function CardOverlayActions({
  children,
  card,
  userId,
  cardGridType,
  selectedCollectionTitle,
  selectedCollectionLive,
  collections,
  viewPrice,
  t,
  setExpandedCardId,
  isValidStringForDeleteCollection,
  onFlip,
  onEdit,
  onDelete,
  onRemoveFromWatchlist,
  onMarkAsSold,
  onAssignCollection,
  removeFromMarketplaceNotForSaleSingle,
  removeFromMarketplaceNotForTradeSingle,
  removeFromMarketplaceNotPC,
  removeFromMarketplaceNotOnEbay,
  onMenuToggle, // (cardId, isOpen)
}) {
  // const {
  //   card, userId, cardGridType,
  //   selectedCollectionTitle, selectedCollectionLive,
  //   collections = [], viewPrice = false, t,
  //   setExpandedCardId = () => {},
  //   isValidStringForDeleteCollection = () => true,

  //   // actions
  //   onFlip, onEdit, onDelete, onRemoveFromWatchlist, onMarkAsSold, onAssignCollection,
  //   removeFromMarketplaceNotForSaleSingle,
  //   removeFromMarketplaceNotForTradeSingle,
  //   removeFromMarketplaceNotPC,
  //   removeFromMarketplaceNotOnEbay,
  //   onMenuToggle
  // } = props;

  const [menuOpen, setMenuOpen] = useState(false);
  const [view, setView] = useState("root"); // 'root' | 'assign' | 'manage'
  const [hideUntilLeave, setHideUntilLeave] = useState(false);
 const [menuArmed, setMenuArmed] = useState(false); // <-- new
  // Refs
  const overlayRef = useRef(null);
  const menuRef = useRef(null);
  const triggerRef = useRef(null);
const armMenuSoon = () => {
  setMenuArmed(false);
  // rAF ensures the panel is in DOM, then arm after a short delay
  requestAnimationFrame(() => {
    setTimeout(() => setMenuArmed(true), 200); // 180–250ms works well
  });
};
  // Ownership / visibility
  const isOwner = useMemo(
    () => String(userId) === String(card?.UserId),
    [userId, card?.UserId]
  );
  const canShowMenu = useMemo(() => {
    const canInSell =
      isOwner &&
      cardGridType === "CardGridSell" &&
      !isValidStringForDeleteCollection(selectedCollectionTitle);
    return canInSell || cardGridType === "CardGrid";
  }, [isOwner, cardGridType, selectedCollectionTitle, isValidStringForDeleteCollection]);


  useEffect(() => {
  onMenuToggle?.(menuOpen, card.id);
}, [menuOpen, card?.id, onMenuToggle]);
  // Flip only on desktop/trackpad (no touch)
  const [canFlip, setCanFlip] = useState(true);
  const detectCanFlip = useCallback(() => {
    const mqFinePointer = typeof window !== "undefined"
      ? window.matchMedia?.("(hover: hover) and (pointer: fine)")?.matches
      : false;
    const hasTouch = typeof navigator !== "undefined"
      ? (navigator.maxTouchPoints > 0 || "ontouchstart" in window)
      : false;
    return !!mqFinePointer && !hasTouch;
  }, []);
  useEffect(() => {
    const setFromDetect = () => setCanFlip(detectCanFlip());
    setFromDetect();
    window.addEventListener("resize", setFromDetect);
    return () => window.removeEventListener("resize", setFromDetect);
  }, [detectCanFlip]);

  const isMobileMode = !canFlip; // shorthand

  // Helpers
  const maybe = (cb, ...args) => () => {
    if (typeof cb === "function") cb(...args);
    setMenuOpen(false);
  
    setView("root");

  };
  const handleAssign = (listId) => {
    onAssignCollection?.(listId, card.id);
    setMenuOpen(false);

    setView("root");
  };

useEffect(() => {
  if (!menuOpen) return;

  // Focus the menu (or first actionable item)
  const first = menuRef.current?.querySelector('.menu-item, [role="menuitem"], button, a');
  (first || menuRef.current)?.focus?.();

  // Close on outside pointerdown + Esc
  const onDocPointer = (e) => {
    const m = menuRef.current;
    const t = triggerRef.current;
    const target = e.target;
    if (!m) return;
    // ignore taps in menu or on trigger
    if (m.contains(target) || (t && t.contains(target))) return;
    setMenuOpen(false);
  };
  const onEsc = (e) => { if (e.key === 'Escape') setMenuOpen(false); };

  document.addEventListener('pointerdown', onDocPointer, { passive: true });
  document.addEventListener('keydown', onEsc);

  // Swallow ONLY the next click that lands OUTSIDE the menu/trigger.
  // Do NOT swallow clicks inside the menu (lets the first tap trigger the button).
  const swallowNextOutsideClick = (e) => {
    const m = menuRef.current;
    const t = triggerRef.current;
    const target = e.target;
    const outside = m && !m.contains(target) && !(t && t.contains(target));
    if (outside) {
      e.preventDefault();
      e.stopPropagation();
    }
    window.removeEventListener('click', swallowNextOutsideClick, true); // one-shot
  };
  window.addEventListener('click', swallowNextOutsideClick, true);

  return () => {
    document.removeEventListener('pointerdown', onDocPointer);
    document.removeEventListener('keydown', onEsc);
    window.removeEventListener('click', swallowNextOutsideClick, true);
  };
}, [menuOpen]);

   // Open menu – use pointerdown to avoid ghost click
  const openMenu = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setView("root");
    setMenuOpen(true);
     armMenuSoon();
  };

  // Close menu
const closeMenu = (e) => {
  e?.preventDefault?.();
  e?.stopPropagation?.();
  if (!menuArmed) return;       // <-- ignore early close
  setMenuOpen(false);
};

  // Focus the first actionable element when menu opens
  useEffect(() => {
    if (!menuOpen) return;
    // wait for the panel to be in the DOM
    Promise.resolve().then(() => {
      const first = menuRef.current?.querySelector(
        ".menu-item, [role='menuitem'], button, a"
      );
      (first || menuRef.current)?.focus?.();
    });
  }, [menuOpen]);

  return (
    <div
      ref={overlayRef}
      className={[
        "card-overlay",
        menuOpen ? "is-menu" : "",
        hideUntilLeave ? "is-hidden" : "",
        (!canFlip ? "is-mobile" : "is-desktop"),
      ].join(" ")}
      // If menu is open, swallow pointer so parent card onClick can't fire
      onPointerDown={(e) => { if (menuOpen) e.stopPropagation(); }}
      onClick={(e) => {
        if (menuOpen) { e.stopPropagation(); return; }
        if (!canFlip) return; // mobile: do not flip
        // e.stopPropagation();
        // onFlip?.(card.id);
        setHideUntilLeave(true);
      }}
      onMouseLeave={() => { if (canFlip) setHideUntilLeave(false); }}
    >
      {/* Corner trigger (visible when menu is closed) */}
      {canShowMenu && !menuOpen && (
        <button
          ref={triggerRef}
          className="corner-actions btn-glass btn-glass--icon" 
          style={{maxWidth:'2.5rem',maxHeight:'2.5rem'}}
          aria-haspopup="menu"
          aria-expanded={menuOpen}
          aria-label={t("More options")}
          onPointerDown={openMenu}    // <-- open here
          disabled={menuOpen && !menuArmed}
        >
          ⋮
        </button>
      )}
      {!menuOpen &&children}

      {/* When open: a full-screen backdrop that eats taps and closes on outside press */}
      {menuOpen && (
        <>
          <div
            className="overlay-backdrop"
            onPointerDown={closeMenu}      // tap outside closes
          />
          <div
            ref={menuRef}
            className="overlay-menu"
            role="menu"
            aria-label={t("Card actions")}
            tabIndex={-1}
            // prevent clicks inside from bubbling to backdrop/overlay
            onPointerDown={(e) => e.stopPropagation()}
            onClick={(e) => e.stopPropagation()}
          >
            {/* ===== ROOT VIEW ===== */}
            {view === "root" && (
              <ul className="menu-list" role="menu">
                <li>
                  <button
                    className="menu-item one-line"
                    role="menuitem"
                    onClick={closeMenu}   
                    disabled={!menuArmed}
                  >
                    <span className="mi-text"><span className="mi-label">✕ {t("Close")}</span></span>
                  </button>
                </li>

                {isOwner && (
                  <>
                    <li>
                      <button
                        className="menu-item one-line"
                        title={t("Update details, price, photos")}
                        role="menuitem"
                        onClick={() => { onEdit?.(card); closeMenu(); }}
                      >
                        <span className="mi-text"><span className="mi-label">✎ {t("Edit")}</span></span>
                      </button>
                    </li>
                    {cardGridType==='CardGrid' && <li>
                      <button className="menu-item one-line" role="menuitem" onClick={() => setView("assign")}>
                        <span className="mi-text"><span className="mi-label">📁 {t("Assign")}</span></span>
                      </button>
                    </li>}
                    <li>
                      <button className="menu-item one-line" role="menuitem" onClick={() => setView("manage")}>
                        <span className="mi-text"><span className="mi-label">⚙️ {t("Manage")}</span></span>
                      </button>
                    </li>
                  </>
                )}

                {selectedCollectionTitle &&
                  selectedCollectionTitle !== "0" &&
                  selectedCollectionTitle !== "MyListings" && (
                    <li>
                      <button
                        className="menu-item"
                        role="menuitem"
                        onClick={() => { onRemoveFromWatchlist?.(card.id); closeMenu(); }}
                      >
                        <span className="mi-text">
                          <span className="mi-label">⭐ {t("Remove from")} "{selectedCollectionTitle}"</span>
                          {/* <span className="mi-sublabel"></span> */}
                        </span>
                      </button>
                    </li>
                  )}

                {isOwner && (
                  <li>
                    <button
                      className="menu-item menu-item--danger"
                      role="menuitem"
                      onClick={() => { onDelete?.(card.id); closeMenu(); }}
                    >
                      <span className="mi-text"><span className="mi-label">🗑️ {t("Delete the card")}</span></span>
                    </button>
                  </li>
                )}
              </ul>
            )}

            {/* ===== ASSIGN VIEW ===== */}
            {view === "assign" && (
              <ul className="menu-list" role="menu">
                <li>
                  <button className="menu-item one-line" role="menuitem" onClick={() => setView("root")}>
                    <span className="mi-text"><span className="mi-label">↩︎ {t("Back")}</span></span>
                  </button>
                </li>
                {collections.map((c) => (
                  <li key={c.ListId}>
                    <button
                      className="menu-item"
                      role="menuitem"
                      onClick={() => { onAssignCollection?.(c.ListId, card.id); closeMenu(); }}
                    >
                      <span className="mi-text"><span className="mi-label">📂 {t("Add to")} "{c.Title}"</span></span>
                    </button>
                  </li>
                ))}
              </ul>
            )}

            {/* ===== MANAGE VIEW ===== */}
            {view === "manage" && (
              <ul className="menu-list" role="menu">
                <li>
                  <button className="menu-item one-line" role="menuitem" onClick={() => setView("root")}>
                    <span className="mi-text"><span className="mi-label">↩︎ {t("Back")}</span></span>
                  </button>
                </li>

                {card?.isForSale === "isForSale" && (
                  <>
                    <li>
                      <button className="menu-item one-line" role="menuitem" onClick={() => { onMarkAsSold?.(card.id); closeMenu(); }}>
                        <span className="mi-text"><span className="mi-label">{t("Mark as Sold")}</span></span>
                      </button>
                    </li>
                    <li>
                      <button className="menu-item one-line" role="menuitem" onClick={() => { removeFromMarketplaceNotForSaleSingle?.(userId, card.id); closeMenu(); }}>
                        <span className="mi-text"><span className="mi-label">{t("Not For Sale")}</span></span>
                      </button>
                    </li>
                  </>
                )}

                {card?.isForTrade === "isForTrade" && (
                  <li>
                    <button className="menu-item one-line" role="menuitem" onClick={() => { removeFromMarketplaceNotForTradeSingle?.(userId, card.id); closeMenu(); }}>
                      <span className="mi-text"><span className="mi-label">{t("Not For Trade")}</span></span>
                    </button>
                  </li>
                )}

                {card?.isPC === "isPC" && (
                  <li>
                    <button className="menu-item one-line" role="menuitem" onClick={() => { removeFromMarketplaceNotPC?.(userId, card.id); closeMenu(); }}>
                      <span className="mi-text"><span className="mi-label">{t("Not PC")}</span></span>
                    </button>
                  </li>
                )}

                {card?.isOnEbay === "isOnEbay" && (
                  <li>
                    <button className="menu-item one-line" role="menuitem" onClick={() => { removeFromMarketplaceNotOnEbay?.(userId, card.id); closeMenu(); }}>
                      <span className="mi-text"><span className="mi-label"> {t("Not On Ebay")}</span></span>
                    </button>
                  </li>
                )}

                {card?.isForSale !== "isForSale" &&
                 card?.isForTrade !== "isForTrade" &&
                 card?.isPC !== "isPC" &&
                 card?.isOnEbay !== "isOnEbay" && (
                  <li>
                    <div className="menu-item one-line" role="presentation" style={{ cursor: "default" }}>
                      <span className="mi-text"><span className="mi-label">ℹ️ {t("Nothing to manage")}</span></span>
                    </div>
                  </li>
                )}
              </ul>
            )}
          </div>
        </>
      )}

    
     

      {/* Desktop flip hint */}
      {!menuOpen && canFlip && (
        <div className="overlay-toprow">
          <div className="flip-hint" onClick={(e) => {e.stopPropagation(); onFlip?.(card.id);}}>⇆ {t("Flip")}</div>
        </div>
      )}


        {/* Prices dock */}
      {!menuOpen && !viewPrice && (
        <div className="overlay-dock">
          <div className="dock-left">
            {card?.isForSale === "isForSale" && (
              <span className="chip chip--outlineBlue">
                {t('Price')} {card.Price <= 0 || card.Price == null ? "0$" : `${card.Price}$`}
              </span>
            )}
            {Number(card?.EstimateValue) >= 1 && (
              <span className="chip chip--primary">TV {card.EstimateValue}$</span>
            )}
          </div>
          <div className="dock-right" />
        </div>
      )}
    </div>
    
  );

}
